module.exports = __webpack_public_path__ + "static/img/default.37f8619.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree3_seed/default.png
// module id = ptRo
// module chunks = 1